module.exports = __webpack_public_path__ + "img/decor-signs-1.a3ff087e.svg";